import Model from "@/models/Model";

export default class JournalTag extends Model {
    resource() {
        return "tags";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }
}
